<template>
    <div>
        <b-form-select
            :disabled="disabled"
            v-model="selected"
            :options="deviceOptions"
        ></b-form-select>
    </div>
</template>

<style scoped>
  select {
    font-size: x-small;
  }
</style>

<script>
export default {
    props: {
        deviceId: {
            type: String,
            default: 'default'
        },

        devices: {
            type: Array,
            default: () => []   // default for Array/Object must use a factory function apparently
        },

        disabled: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        selected: {
            get() {
                return this.deviceId;
            },
            set(value) {
                this.$emit('change', value);
            }
        },

        deviceOptions() {
            return this.devices.map(device => {
                return {
                    value: device.deviceId,
                    text: device.label
                }
            });
        },
    },
};
</script>